import React, { Fragment, useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { H4 } from "../../../AbstractElements";
import useAxios from "../../../Utils/useAxios";
import { convertRPInputToIntValue } from "../../../Utils/otherFunctions";
import { formatRP } from "../../../Utils/externalFunctions";
import { FORM_TYPE } from "../../../Constant/FormType";
import { APISentFailedMsg, APISentSuccessMsg, getItemCreateSuccessMsg, getItemEditSuccessMsg } from "../../../Constant/Message";
import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";
import { useNavigate } from "react-router-dom";
import TabTriwulanCapaianSS from "./TabTriwulanCapaianSS";

const FormCapaianSS = ({
  formCapaianSS,
  setFormCapaianSS,
  formType
}) => {
  const axiosInstance = useAxios()
  const navigate = useNavigate();
  const [entitasList, setEntitasList] = useState([]);
  const [perspektifList, setPerspektifList] = useState([]);
  const [sasaranStrategisList, setSasaranStrategisList] = useState([]);
  const [formattedNumber, setFormattedNumber] = useState({
    anggaran: "0",
    komitmen: "0",
    aktual: "0",
    sisa_anggaran: "0"
  })
  const [isInvalid, setIsInvalid] = useState({
    "bobot_sasaran_strategis": false,
    "capaian_tw_1": false,
    "capaian_tw_2": false,
    "capaian_tw_3": false,
    "capaian_tw_4": false,
    "capaian_normalisasi_tw_1": false,
    "capaian_normalisasi_tw_2": false,
    "capaian_normalisasi_tw_3": false,
    "capaian_normalisasi_tw_4": false,
    "nilai_sasaran_strategis_tw_1": false,
    "nilai_sasaran_strategis_tw_2": false,
    "nilai_sasaran_strategis_tw_3": false,
    "nilai_sasaran_strategis_tw_4": false,
    "nilai_sasaran_strategis_normalisasi_tw_1": false,
    "nilai_sasaran_strategis_normalisasi_tw_2": false,
    "nilai_sasaran_strategis_normalisasi_tw_3": false,
    "nilai_sasaran_strategis_normalisasi_tw_4": false
  })

  let isMounted = true;
  useEffect(() => {
    fetchData("entitas/", setEntitasList);
    fetchData("perspektif/", setPerspektifList);
    fetchData("sasaran-strategis/", setSasaranStrategisList);

    return() => {
      isMounted=false
    }
  }, [])

  useEffect(() => {

    const formatValues = ["anggaran", "komitmen", "aktual", "sisa_anggaran"];
    formatValues.forEach((key) => {
      if (formCapaianSS[key] > 0) {
        setFormattedNumber((prev) => ({
          ...prev,
          [key]: formatRP(formCapaianSS[key])
        }));
    }})

  }, [formCapaianSS])

  const fetchData = async (endpoint, setData) => {
    try {
      const response = await axiosInstance.get(endpoint);
      if (isMounted) {
        setData(response.data);
        if (response.data.length === 1) {
          switch (endpoint) {
            case "entitas/":
              setFormCapaianSS((prevState) => ({
                ...prevState,
                entitas: `${response.data[0].kode_entitas} - ${response.data[0].nama_entitas}`,
              }));
              break;
            case "perspektif/":
              setFormCapaianSS((prevState) => ({
                ...prevState,
                perspektif: response.data[0].nama_perspektif,
              }));
              break;
            case "sasaran-strategis/":
              setFormCapaianSS((prevState) => ({
                ...prevState,
                kode_ss: response.data[0].kode_sasaran_strategis,
                nama_ss: response.data[0].nama_sasaran_strategis,
              }));
              break;
            default:
              break;
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangeForm = (e) => {
    const { name, value } = e.target;

    const valuesToCheck = [
      "bobot_sasaran_strategis",
      "capaian_tw_1", "capaian_tw_2", "capaian_tw_3", "capaian_tw_4",
      "capaian_normalisasi_tw_1", "capaian_normalisasi_tw_2", "capaian_normalisasi_tw_3", "capaian_normalisasi_tw_4", 
      "nilai_sasaran_strategis_tw_1", "nilai_sasaran_strategis_tw_2", "nilai_sasaran_strategis_tw_3", "nilai_sasaran_strategis_tw_4", 
      "nilai_sasaran_strategis_normalisasi_tw_1", "nilai_sasaran_strategis_normalisasi_tw_2", "nilai_sasaran_strategis_normalisasi_tw_3", "nilai_sasaran_strategis_normalisasi_tw_4",  
    ];

    // mengubah format mata uang sebelum dimasukkan ke form
    if (name === "anggaran" || name === "komitmen" || name === "aktual" || name === "sisa_anggaran") {
      const numericValue = convertRPInputToIntValue(value)
      // const formatRPValue = formatRP(numericValue)

      setFormCapaianSS((prev) => ({
        ...prev,
        [name]: numericValue
      }))
      // setFormattedNumber((prevState) => ({
      //   ...prevState,
      //   [name]: formatRPValue
      // }))
    } else {
      setFormCapaianSS((prev) => ({
        ...prev,
        [name]: value,
      }))
    }

    //  cek jika nilai persen berada diantara 0 - 999
    if (valuesToCheck.includes(name) && (value < 0 || value > 999)) {
      setIsInvalid((prevState) => ({
        ...prevState,
        [name]: true,
      }))
    } else if (valuesToCheck.includes(name) && (value >= 0 && value <= 999)) {
      setIsInvalid((prevState) => ({
        ...prevState,
        [name]: false,
      }))

    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // setWaitingForSubmit(true);
      if (formType === FORM_TYPE.Create) {
        const response = await axiosInstance.post(`capaian-ss/`, formCapaianSS)
        if (response.status === 201) {
          console.log(APISentSuccessMsg);
          toast.success(getItemCreateSuccessMsg("Capaian SS"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: timeToast,
          });
          navigate(`${process.env.PUBLIC_URL}/capaianss/`);
        }
      } else if (formType === FORM_TYPE.Edit){
        const response = await axiosInstance.put(`capaian-ss/${formCapaianSS.id}`, formCapaianSS)
        if (response.status === 201) {
          console.log(APISentSuccessMsg);
            toast.success(getItemEditSuccessMsg("capaian SS"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: timeToast,
            });
            navigate(`${process.env.PUBLIC_URL}/capaianss/`);
        }
      }
    } catch (e) {
      console.log(APISentFailedMsg);
      toast.error(e.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      // setWaitingForSubmit(false);
    }
  }

  return(
    <Fragment>
      <Container fluid={true}>
        <Card>
          <CardHeader>
            <H4>Form Capaian SS</H4>
          </CardHeader>
          <CardBody>
            <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="entitas">Entitas</Label>
                  <Input
                    id="entitas"
                    name="entitas"
                    type="select"
                    value={formCapaianSS.entitas}
                    onChange={(e) => handleChangeForm(e)}
                  >
                    {entitasList.length > 1 && <option>-------</option>}
                    {entitasList.map((item) => (
                      <option key={item.id} value={item.nama_entitas}>{item.kode_entitas} - {item.nama_entitas}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="perspektif">Perspektif</Label>
                  <Input
                    id="perspektif"
                    name="perspektif"
                    type="select"
                    value={formCapaianSS.perspektif}
                    onChange={(e) => handleChangeForm(e)}
                  >
                    {perspektifList.length > 1 && <option>-------</option>}
                    {perspektifList.map((item) => (
                      <option key={item.id} value={item.nama_perspektif}>{item.nama_perspektif}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="kode_ss">Kode Sasaran Strategis</Label>
                  <Input
                    id="kode_ss"
                    name="kode_ss"
                    type="select"
                    value={formCapaianSS.kode_ss}
                    onChange={(e) => handleChangeForm(e)}
                  >
                    {sasaranStrategisList.length > 1 && <option>-------</option>}
                    {sasaranStrategisList.map((item) => (
                      <option key={item.pk} value={item.kode_sasaran_strategis}>{item.kode_sasaran_strategis}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="nama_ss">Nama Sasaran Strategis</Label>
                  <Input
                    id="nama_ss"
                    name="nama_ss"
                    type="select"
                    value={formCapaianSS.nama_ss}
                    onChange={(e) => handleChangeForm(e)}
                  >
                    {sasaranStrategisList.length > 1 && <option>-------</option>}
                    {sasaranStrategisList.map((item) => (
                      <option key={item.pk} value={item.nama_sasaran_strategis}>{item.nama_sasaran_strategis}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="bobot_sasaran_strategis">Bobot SS</Label>
                  <Input
                    id="bobot_sasaran_strategis"
                    name="bobot_sasaran_strategis"
                    type="number"
                    max="999"
                    min="0"
                    invalid={isInvalid.bobot_sasaran_strategis}
                    value={formCapaianSS.bobot_sasaran_strategis}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label for="anggaran">Anggaran</Label>
                  <Input
                    id="anggaran"
                    name="anggaran"
                    type="text"
                    value={formattedNumber.anggaran}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label for="komitmen">Komitmen</Label>
                  <Input
                    id="komitmen"
                    name="komitmen"
                    type="text"
                    value={formattedNumber.komitmen}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label for="aktual">Aktual</Label>
                  <Input
                    id="aktual"
                    name="aktual"
                    type="text"
                    value={formattedNumber.aktual}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label for="sisa_anggaran">Sisa Anggaran</Label>
                  <Input
                    id="sisa_anggaran"
                    name="sisa_anggaran"
                    type="text"
                    value={formattedNumber.sisa_anggaran}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <TabTriwulanCapaianSS
              handleChangeForm={handleChangeForm}
              formCapaianSS={formCapaianSS}
              isInvalid={isInvalid}
              // statusCapaianList={statusCapaianList}
            />
            <div className="text-end">
              <Button
                // disabled={isSubmitDisable}
                onClick={(e) => {handleSubmit(e)}}
              >
                Submit
              </Button>
            </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </Fragment>
  )
}

export default FormCapaianSS;